export class ClsDistanciaNegocioModel {
  public ND_NEGO_ID :number;
  public ND_PARAM_ID: number;
  public ND_ESTADO: string;
  public PARAM_DESCRIP: string;
}
